const Local = {
  get: (item) => typeof localStorage !== 'undefined' && localStorage.getItem(item),
  set: (item, value) => typeof localStorage !== 'undefined' && localStorage.setItem(item, value),
  remove: (item) => typeof localStorage !== 'undefined' && localStorage.removeItem(item),
  // clear: () => window.localStorage.clear()
};

export default Local;
